import Vue from 'vue';
import axios from 'axios';
import '../../filters';
import moment from 'moment';
import JsonExcel from 'vue-json-excel';

Vue.component('downloadExcel', JsonExcel);

export default {
  name: 'debtManagement',
  components: {
    TreeSelect: require('../../customcontrols/selectOfTree.vue').default,
    loadingSnippet: require('../../common/loadingSnippet/loadingSnippet.vue').default,
    reportsComp: require('../../common/reports/reports.vue').default,
    customButtonComp: require('./customButton.vue').default
  },
  data: function () {
    return {
      currentTab: 'tab-Statistics',
      disableDetailsTab: true,
      settings: {},
      billingGroups: [],
      billingGroup: '',
      projects: [],
      project: 0,
      withOpenCases: 0,
      withoutCases: 0,
      totalCustomers: 0,
      breakdown: null,

      statuses: [],
      stages: [],
      matrix: [],
      showItemData: false,
      showLoadingData: false,
      currentItem: {
        data: [],
        loading: false,
        move: false
      },
      dataColumns: [],
      currentSort: 'account',
      currentSortOrder: 'asc',
      reports: [],
      showReportsDialog: false,
      detailsLabel: '',
      selectedItems: [],
      statusEnumId: '',
      stageEnumId: '',
      itemsMovableButtons: [],
      showBatchesDialog: false,
      selectedBatchNo: 0,
      batches: [],
      showCreateNewBatchDialog: false,
      newBatch: {
        activityStage: -1,
        description: '',
        assginedDate: null,
        assignedEmployeeId: 0,
        assignedDetails: ''
      },
      fun: '',
      showProcessingData: false,
      processFuncsDivider: '_',
      disconnectionsSubItems: ['Assigned', 'Authorized', 'Completed', 'Outstanding'],
      disconnectionsPropSubItems: ['DiscCompletedNoProp', 'DiscOutstandingNoProp'],
      reconnectionsSubItems: ['Assigned', 'Outstanding'],
      breakdownData: [],
      stagesEnum: [
        { id: 0, name: 'Reminders1' },
        { id: 1, name: 'Reminders2' },
        { id: 2, name: 'Disconnections' },
        { id: 3, name: 'Summons' },
        { id: 5, name: 'Reconnections' }
      ],
      statusEnum: [
        { id: 0, name: 'Outstanding' },
        { id: 1, name: 'Authorized' },
        { id: 2, name: 'Assigned' },
        { id: 3, name: 'Completed' },
        { id: 9, name: 'DiscOutstandingNoProp' },
        { id: 10, name: 'DiscCompletedNoProp' }
      ],
      showFlow: false
    };
  },
  computed: {},
  watch: {},
  created() {
    this.$material.locale.dateFormat = 'dd/MM/yyyy';
    this.getSettings();
    this.fillItemsColumns();
    this.getReports();
    this.fillMetaData();
    this.fillMatrix();
  },
  methods: {
    getBreakdownValue(stageId, statuseId) {
      const val = this.breakdown[stageId][statuseId];
      return val;
    },
    getStageTotal(stageId, isDisconnectionsProps) {
      let val = 0;

      if (this.breakdown[stageId] === undefined || this.breakdown[stageId] === null) return 0;

      const keys: string[] = Object.keys(this.breakdown[stageId]);

      if (keys === undefined || keys === null) return 0;

      for (let i = 0; i < keys.length; i++) {
        if (stageId === 'Disconnections') {
          if (isDisconnectionsProps) {
            if (this.disconnectionsPropSubItems.filter((a) => a === keys[i]).length > 0) {
              val += this.breakdown[stageId][keys[i]];
            }
          } else {
            if (this.disconnectionsSubItems.filter((a) => a === keys[i]).length > 0) {
              val += this.breakdown[stageId][keys[i]];
            }
          }
        } else if (stageId === 'Reconnections') {
          if (this.reconnectionsSubItems.filter((a) => a === keys[i]).length > 0) {
            val += this.breakdown[stageId][keys[i]];
          }
        } else {
          val += this.breakdown[stageId][keys[i]];
        }
      }

      return val;
    },
    getSettings() {
      axios
        .get('/DmCase/GetSettings')
        .then((response) => {
          if (response.status == 200) {
            this.settings = response.data;
            this.fillBillingGroups();
            this.fillProjects();
          }
        })
        .catch((err) => {
          this.$alertMsg(err.response.data, 4);
        });
    },
    fillMatrix() {
      this.matrix.push({
        id: 0,
        rowName: 'outstanding',
        breakdownName: 'Outstanding',
        cols: [
          {
            colName: 'reminders1st',
            breakdownNames: [
              {
                name: 'Reminders1',
                move: [
                  { title: 'authorise', fun: 'ProcessOutstandingToAuthorize' },
                  {
                    title: 'authoriseAssignToNewBatch',
                    fun: `ProcessOutstandingToAuthorize`,
                    createBatch: true,
                    selectBatch: false,
                    icon: 'handshake'
                  },
                  { title: 'authoriseAssignToBatch', fun: `ProcessOutstandingToAuthorize`, createBatch: false, selectBatch: true, icon: 'handshake' }
                ]
              }
            ]
          },
          {
            colName: 'reminders2nd',
            breakdownNames: [
              {
                name: ''
              }
            ]
          },
          {
            colName: 'disconnections',
            breakdownNames: [
              {
                name: 'Disconnections',
                move: [
                  { title: 'authorise', fun: 'ProcessOutstandingToAuthorize' },
                  {
                    title: 'authoriseAssignToNewBatch',
                    fun: 'ProcessAuthorizedToAddToBatch',
                    createBatch: true,
                    selectBatch: false,
                    icon: 'handshake'
                  },
                  { title: 'authoriseAssignToBatch', fun: 'ProcessAuthorizedToAddToBatch', createBatch: false, selectBatch: true, icon: 'handshake' }
                ]
              },
              {
                name: 'DiscOutstandingNoProp',
                move: [
                  { title: 'authorise', fun: 'ProcessOutstandingToAuthorize' },
                  {
                    title: 'authoriseAssignToNewBatch',
                    fun: 'ProcessAuthorizedToAddToBatch',
                    createBatch: true,
                    selectBatch: false,
                    icon: 'handshake'
                  },
                  { title: 'authoriseAssignToBatch', fun: 'ProcessAuthorizedToAddToBatch', createBatch: false, selectBatch: true, icon: 'handshake' }
                ]
              }
            ]
          },
          {
            colName: 'reconnections',
            breakdownNames: [
              {
                name: 'Reconnections',
                move: [
                  { title: 'assignToNewBatch', fun: 'ProcessAuthorizedToAddToBatch', createBatch: true, selectBatch: false, icon: 'handshake' },
                  { title: 'assignToBatch', fun: 'ProcessAuthorizedToAddToBatch', createBatch: false, selectBatch: true, icon: 'handshake' }
                ]
              }
            ]
          },
          {
            colName: 'summmons',
            breakdownNames: [
              {
                name: 'Summons',
                move: [
                  { title: 'authorise', fun: 'ProcessOutstandingToAuthorize' },
                  {
                    title: 'authoriseAssignToNewBatch',
                    fun: 'ProcessAuthorizedToAddToBatch',
                    createBatch: true,
                    selectBatch: false,
                    icon: 'handshake'
                  },
                  { title: 'authoriseAssignToBatch', fun: 'ProcessAuthorizedToAddToBatch', createBatch: false, selectBatch: true, icon: 'handshake' }
                ]
              }
            ]
          },
          {
            colName: 'badDebts',
            breakdownNames: [
              {
                name: 'BadDebts',
                move: [
                  { title: 'authorise', fun: 'ProcessOutstandingToAuthorize' },
                  {
                    title: 'authoriseAssignToNewBatch',
                    fun: 'ProcessAuthorizedToAddToBatch',
                    createBatch: true,
                    selectBatch: false,
                    icon: 'handshake'
                  },
                  { title: 'authoriseAssignToBatch', fun: 'ProcessAuthorizedToAddToBatch', createBatch: false, selectBatch: true, icon: 'handshake' }
                ]
              }
            ]
          }
        ]
      });

      this.matrix.push({
        id: 1,
        rowName: 'authorised',
        breakdownName: 'Authorized',
        cols: [
          {
            colName: 'reminders1st',
            breakdownNames: [
              {
                name: 'Reminders1',
                move: [
                  { title: 'assignToNewBatch', fun: 'ProcessAuthorizedToAddToBatch', createBatch: true, selectBatch: false, icon: 'handshake' },
                  { title: 'assignToBatch', fun: 'ProcessAuthorizedToAddToBatch', createBatch: false, selectBatch: true, icon: 'handshake' },
                  { title: 'unAuthorise', fun: 'ProcessAuthorizedToUnAuthorize', icon: 'clear' }
                ]
              }
            ]
          },
          { colName: 'reminders2nd', breakdownNames: [{ name: '' }] },
          {
            colName: 'disconnections',
            breakdownNames: [
              {
                name: 'Disconnections',
                move: [
                  { title: 'assignToNewBatch', fun: 'ProcessAuthorizedToAddToBatch', createBatch: true, selectBatch: false, icon: 'handshake' },
                  { title: 'assignToBatch', fun: 'ProcessAuthorizedToAddToBatch', createBatch: false, selectBatch: true, icon: 'handshake' },
                  { title: 'unAuthorise', fun: 'ProcessAuthorizedToUnAuthorize', icon: 'clear' }
                ]
              },
              null
            ]
          },
          { colName: 'reconnections', breakdownNames: [null] },
          {
            colName: 'summmons',
            breakdownNames: [
              {
                name: 'Summons',
                move: [
                  { title: 'assignToNewBatch', fun: 'ProcessAuthorizedToAddToBatch', createBatch: true, selectBatch: false, icon: 'handshake' },
                  { title: 'assignToBatch', fun: 'ProcessAuthorizedToAddToBatch', createBatch: false, selectBatch: true, icon: 'handshake' },
                  { title: 'unAuthorise', fun: 'ProcessAuthorizedToUnAuthorize', icon: 'clear' }
                ]
              }
            ]
          },
          { colName: 'badDebts', breakdownNames: [{ name: 'BadDebts' }] }
        ]
      });

      this.matrix.push({
        id: 2,
        rowName: 'assigned',
        breakdownName: 'Assigned',
        cols: [
          {
            colName: 'reminders1st',
            breakdownNames: [
              {
                name: 'Reminders1',
                move: [
                  { title: 'complete', fun: 'ProcessAssignedToComplete' },
                  { title: 'deAssign', fun: 'ProcessAssignedToDeAssign', icon: 'clear' }
                ]
              }
            ]
          },
          { colName: 'reminders2nd', breakdownNames: [{ name: '' }] },
          {
            colName: 'disconnections',
            breakdownNames: [
              {
                name: 'Disconnections',
                move: [
                  { title: 'complete', fun: 'ProcessAssignedToComplete' },
                  { title: 'deAssign', fun: 'ProcessAssignedToDeAssign', icon: 'clear' }
                ]
              },
              null
            ]
          },
          { colName: 'reconnections', breakdownNames: [{ name: 'Assigned' }] },
          {
            colName: 'summmons',
            breakdownNames: [
              {
                name: 'Summons',
                move: [
                  { title: 'complete', fun: 'ProcessAssignedToComplete' },
                  { title: 'deAssign', fun: 'ProcessAssignedToDeAssign', icon: 'clear' }
                ]
              }
            ]
          },
          { colName: 'badDebts', breakdownNames: [{ name: 'BadDebts' }] }
        ]
      });

      this.matrix.push({
        id: 3,
        rowName: 'completed',
        breakdownName: 'Completed',
        cols: [
          { colName: 'reminders1st', breakdownNames: [{ name: 'Reminders1' }] },
          { colName: 'reminders2nd', breakdownNames: [{ name: '' }] },
          { colName: 'disconnections', breakdownNames: [{ name: 'Disconnections' }, { name: 'DiscCompletedNoProp' }] },
          { colName: 'reconnections', breakdownNames: [null] },
          { colName: 'summmons', breakdownNames: [{ name: 'Summons' }] },
          { colName: 'badDebts', breakdownNames: [null] }
        ]
      });
    },
    fillMetaData() {
      this.statuses.push({
        id: 0,
        name: 'outstanding',
        breakdownName: 'Outstanding',
        enumId: 0
      });

      this.statuses.push({
        id: 1,
        name: 'authorised',
        breakdownName: 'Authorized',
        enumId: 1
      });

      this.statuses.push({
        id: 2,
        name: 'assigned',
        breakdownName: 'Assigned',
        enumId: 2
      });

      this.statuses.push({
        id: 3,
        name: 'completed',
        breakdownName: 'Completed',
        enumId: 3
      });

      //==================

      this.stages.push({
        id: 0,
        name: 'reminders1st',
        breakdownName: 'Reminders1',
        enumId: 0
      });

      this.stages.push({
        id: 1,
        name: 'reminders2nd',
        breakdownName: '',
        enumId: 1
      });

      this.stages.push({
        id: 2,
        name: 'disconnections',
        breakdownName: 'Disconnections',
        enumId: 2
      });

      //this.stages.push({
      //  id: 3,
      //  name: '',
      //  breakdownName: 'DiscOutstandingNoProp'
      //});

      this.stages.push({
        id: 4,
        name: 'reconnections',
        breakdownName: 'Reconnections',
        enumId: 5
      });

      this.stages.push({
        id: 5,
        name: 'summmons',
        breakdownName: 'Summons',
        enumId: 3
      });

      this.stages.push({
        id: 6,
        name: 'badDebts',
        breakdownName: 'BadDebts',
        enumId: 4
      });

      this.stages.push({
        id: 7,
        name: 'bdProvision',
        breakdownName: '',
        enumId: 0
      });
    },
    fillBillingGroups() {
      for (var i = 0; i < this.settings.billingGroups.length; i++) {
        this.billingGroups.push({
          id: this.settings.billingGroups[i].id,
          label: this.settings.billingGroups[i].name
        });
      }

      if (this.billingGroups.length > 0) this.billingGroup = this.billingGroups[0].id;
    },
    fillProjects() {
      for (var i = 0; i < this.settings.dmProjects.length; i++) {
        this.projects.push({
          id: this.settings.dmProjects[i].id,
          label: this.settings.dmProjects[i].name,
          obj: this.settings.dmProjects[i]
        });
      }

      if (this.projects.length > 0) this.project = this.projects[0].id;
    },
    loadProject() {
      this.showLoadingData = true;

      axios
        .post(`/DmCase/GetStatistics?billingGroupId=${this.billingGroup}&projectId=${this.project}`)
        .then((response) => {
          if (response.status == 200) {
            this.withOpenCases = response.data.activeCases;
            this.withoutCases = response.data.withoutCases;
            this.totalCustomers = response.data.totalCustomers;

            this.breakdown = response.data.breakdown;

            this.showLoadingData = false;
          }
        })
        .catch((err) => {
          this.$alertMsg(err.response.data, 4);
        });
    },
    getValue(stageId, statuseId) {
      console.log(stageId, statuseId);

      if (statuseId == 'DiscOutstandingNoProp') {
        if (!this.breakdown['Disconnections']) return 0;
        else return this.breakdown['Disconnections']['DiscOutstandingNoProp'];
      } else if (statuseId == 'DiscCompletedNoProp') {
        if (!this.breakdown['Disconnections']) return 0;
        else return this.breakdown['Disconnections']['DiscCompletedNoProp'];
      }

      if (!this.breakdown[statuseId]) return 0;

      //return 0;
      //if (!this.breakdown[statuseId]) {
      //  console.log(this.breakdown, stageId, statuseId);
      //  return '0';
      //}

      return this.breakdown[statuseId][stageId] == null ? '0' : this.breakdown[statuseId][stageId];
    },
    getBreakdownData(activityStage, status) {
      this.showItemData = false;
      this.showLoadingData = true;

      if (this.breakdownData.filter((a) => a.itemsStage === activityStage && a.itemsStatus === status).length === 0) {
        axios
          .post(
            `/DmCase/GetItems?billingGroupId=${this.billingGroup == null ? '' : this.billingGroup}&projectId=${this.project}
            &activityStage=${activityStage}&status=${status}&filter=''%+&includeLastPayments=true&includeBalance=true&pageIndex=0&pageSize=1000`
          )
          .then((response) => {
            if (response.status == 200) {
              this.currentItem.data = response.data.items;

              this.breakdownData.push({
                itemsStage: activityStage,
                itemsStatus: status,
                items: response.data.items
              });

              this.currentItem.loading = false;

              this.showLoadingData = false;
              this.showItemData = true;
              this.getDetailsTabTitle(status, activityStage);
              this.disableDetailsTab = false;
              this.currentTab = 'tab-Details';
            }
          })
          .catch((err) => {
            console.log(err);
            this.$alertMsg(err.response.data, 4);
          });
      } else {
        this.showLoadingData = true;

        setTimeout(() => {
          this.currentItem.data = this.breakdownData.filter((a) => a.itemsStage === activityStage && a.itemsStatus === status)[0].items;
          this.showItemData = true;
          this.showLoadingData = false;
          this.getDetailsTabTitle(status, activityStage);
          this.disableDetailsTab = false;
          this.currentTab = 'tab-Details';
        }, 500);
      }
    },
    getItems(status, stage, col) {
      this.showItemData = false;

      this.statusEnumId =
        stage == 'DiscOutstandingNoProp' ? 9 : stage == 'DiscCompletedNoProp' ? 10 : this.statuses.filter((a) => a.breakdownName == status)[0].enumId;
      this.stageEnumId =
        stage == 'DiscOutstandingNoProp' ? 2 : stage == 'DiscCompletedNoProp' ? 2 : this.stages.filter((a) => a.breakdownName == stage)[0].enumId;

      this.currentItem = this.matrix
        .filter((a) => a.breakdownName == status)[0]
        .cols.filter((a) => a.colName == col)[0]
        .breakdownNames.filter((a) => a != null)
        .filter((a) => a.name == stage)[0];

      console.log(this.statusEnumId);
      console.log(this.stageEnumId);
      console.log(this.currentItem);

      if (this.currentItem.data) {
        this.showLoadingData = true;

        setTimeout(() => {
          this.showItemData = true;
          this.showLoadingData = false;
          this.getDetailsTabTitle(status, stage, col);
          this.disableDetailsTab = false;
          this.currentTab = 'tab-Details';
        }, 500);
      } else {
        this.currentItem.loading = true;
        this.showLoadingData = true;

        axios
          .post(
            `/DmCase/GetItems?billingGroupId=${this.billingGroup == null ? '' : this.billingGroup}&projectId=${this.project}
            &activityStage=${this.stageEnumId}&status=${
              this.statusEnumId
            }&filter=''%+&includeLastPayments=true&includeBalance=true&pageIndex=0&pageSize=1000`
          )
          .then((response) => {
            if (response.status == 200) {
              this.currentItem.data = response.data.items;

              this.currentItem.loading = false;

              this.showLoadingData = false;
              this.showItemData = true;
              this.getDetailsTabTitle(status, stage, col);
              this.disableDetailsTab = false;
              this.currentTab = 'tab-Details';
            }
          })
          .catch((err) => {
            this.$alertMsg(err.response.data, 4);
          });
      }
    },
    getDetailsTabTitle(status, stage) {
      this.detailsLabel = this.stagesEnum.filter((a) => a.id === stage)[0].name + ' - ' + this.statusEnum.filter((a) => a.id === status)[0].name;
    },
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;

        if (this.currentSortOrder === 'desc') {
          return a[sortBy].toString().localeCompare(b[sortBy]);
        }

        return b[sortBy].toString().localeCompare(a[sortBy]);
      });
    },
    changeTab(e) {
      this.currentTab = e;

      if (e == 'tab-Statistics') {
        this.disableDetailsTab = true;
        this.selectedItems = [];
      } else {
        this.itemsMovableButtons = [];
      }
    },
    getReports() {
      axios
        .get('/DmCase/GetReports')
        .then((response) => {
          if (response.status == 200) {
            this.reports = response.data;
          }
        })
        .catch((err) => {
          this.$alertMsg(err.response.data, 4);
        });
    },
    printReport(reportId) {
      axios
        .post('/DmCase/CreateReport?reportId=' + reportId)
        .then((response) => {
          if (response.status == 200) {
            window.open(response.data, '_blank');
          } else this.$alertMsg(response.data.data.text, 4);
        })
        .catch((err) => {
          this.$alertMsg(err.response.data, 4);
        });
    },
    fillItemsColumns() {
      this.dataColumns = [];

      this.dataColumns.push({ title: 'caseNo', dataField: 'caseId' });
      this.dataColumns.push({ title: 'billingGroup', dataField: 'billingGroup' });
      this.dataColumns.push({ title: 'account', dataField: 'account' });
      this.dataColumns.push({ title: 'name', dataField: 'name' });
      this.dataColumns.push({ title: 'amountDue', dataField: 'balance' });
      this.dataColumns.push({ title: 'generatedOn', dataField: 'creationDate', isDate: true });
      this.dataColumns.push({ title: 'lastEvaluated', dataField: 'evaluationDate', isDate: true });
      this.dataColumns.push({ title: 'authorizedOn', dataField: 'authorizeDate', isDate: true });
      this.dataColumns.push({ title: 'step', dataField: 'step' });
      this.dataColumns.push({ title: 'underInvestigationStatus', dataField: 'underInvestigation' });
      this.dataColumns.push({ title: 'lastAmountPaid', dataField: 'lastPaymentAmount' });
      this.dataColumns.push({ title: 'lastPaidOn', dataField: 'lastPaymentDate', isDate: true });
      this.dataColumns.push({ title: 'cellTelNo', dataField: 'cellTelNo' });
      this.dataColumns.push({ title: 'consumerType', dataField: 'consumerType' });
      this.dataColumns.push({ title: 'customerWalkRoute', dataField: 'customerBookWalk' });
      this.dataColumns.push({ title: 'batchNo', dataField: 'batchNo' });
      this.dataColumns.push({ title: 'completedOn', dataField: 'completedDate', isDate: true });

      //this.dataColumns.push('canForceClose');

      //this.dataColumns.push('clockOver');
      //this.dataColumns.push('comment');
      //this.dataColumns.push('connectionConnNo');
      //this.dataColumns.push('connectionId');
      //this.dataColumns.push('connectionIsObsolete');
      //this.dataColumns.push('consumptionType');

      //this.dataColumns.push('currentDueAmount');
      //this.dataColumns.push('customerAddress');
      //this.dataColumns.push('customerAgreementReference');
      //this.dataColumns.push('disconnectionAmount');
      //this.dataColumns.push('excludedFromProcess');
      //this.dataColumns.push('finalReadingDate');
      //this.dataColumns.push('finalReadingValue');
      //this.dataColumns.push('gpsX');
      //this.dataColumns.push('gpsY');
      //this.dataColumns.push('infoFlag1');
      //this.dataColumns.push('infoFlag2');
      //this.dataColumns.push('infoFlag3');
      //this.dataColumns.push('infoFlag4');
      //this.dataColumns.push('infoFlag5');
      //this.dataColumns.push('isPropertyOwner');
      //this.dataColumns.push('isPropertyTenant');
      //this.dataColumns.push('isStepValidForCompletion');

      //this.dataColumns.push('meterBookWalk');
      //this.dataColumns.push('meterId');
      //this.dataColumns.push('meterRef');

      //this.dataColumns.push('pdop');
      //this.dataColumns.push('policy');
      //this.dataColumns.push('previousReadingValue');
      //this.dataColumns.push('project');
      //this.dataColumns.push('propertyAddress');
      //this.dataColumns.push('propertyComment');
      //this.dataColumns.push('propertyId');
      //this.dataColumns.push('propertyRef');
      //this.dataColumns.push('requestNo');

      //this.dataColumns.push('stepChargesIssued');
      //this.dataColumns.push('stepSequence');
      //this.dataColumns.push('township');
    },
    formatDate(date) {
      if (date === null) return '';
      return moment(date).format('DD/MM/YYYY');
    },
    onSelectItem(items) {
      this.selectedItems = items;
    },
    prepareProcessItems(func, allowCreateBatch, allowSelectBatch) {
      if (this.selectedItems.length == 0) {
        this.$alertMsg(this.$t('deptManagement.thereIsNoAccountsSelected'), 4);
        return;
      }

      if (func == '') {
        this.$alertMsg('Invalid Process Function', 4);
        return;
      }

      this.fun = func;

      if (allowCreateBatch) {
        this.restNewBatchObj();
        this.showCreateNewBatchDialog = true;
      }

      if (allowSelectBatch) {
        this.getBatches();
      }

      if (!allowCreateBatch && !allowSelectBatch) this.processItems();
    },
    async processItemsAsync() {
      this.showProcessingData = true;
      this.showLoadingData = true;

      const items = [];

      for (var i = 0; i < this.selectedItems.length; i++) {
        items.push({
          Account: this.selectedItems[i].account,
          CaseId: this.selectedItems[i].caseId
        });
      }

      const parameters = {
        ActivityStage: this.stageEnumId,
        BatchNo: this.selectedBatchNo,
        DmCases: items
      };

      const funcs = this.fun.split(this.processFuncsDivider);

      for (var i = 0; i < funcs.length; i++) {
        await axios
          .post(`/DmCase/${funcs[i]}`, parameters)
          .then((response) => {
            if (response.status == 200) {
              if (i == funcs.length - 1) this.getItemsAfterMove();
            } else this.$alertMsg(response.data.data.text, 4);
          })
          .catch((err) => {
            this.$alertMsg(err.response.data, 4);
          });
      }
    },
    processItems() {
      if (this.fun.includes(this.processFuncsDivider)) {
        this.processItemsAsync();
        return;
      }

      this.showProcessingData = true;
      this.showLoadingData = true;

      const items = [];
      let accountsNotValidForComplete = '';

      for (var i = 0; i < this.selectedItems.length; i++) {
        if (this.fun == 'ProcessAssignedToComplete') {
          if (this.selectedItems[i].isStepValidForCompletion) {
            items.push({
              Account: this.selectedItems[i].account,
              CaseId: this.selectedItems[i].caseId
            });
          } else {
            accountsNotValidForComplete += accountsNotValidForComplete == '' ? this.selectedItems[i].account : ` - ${this.selectedItems[i].account}`;
          }
        } else {
          items.push({
            Account: this.selectedItems[i].account,
            CaseId: this.selectedItems[i].caseId
          });
        }
      }

      if (accountsNotValidForComplete != '')
        this.$alertMsg(accountsNotValidForComplete + ' ' + this.$t('deptManagement.accountsNotValidForComplete'), 4);

      if (items.length == 0) {
        this.showProcessingData = false;
        this.showLoadingData = false;
        return;
      }

      const parameters = {
        ActivityStage: this.stageEnumId,
        BatchNo: this.selectedBatchNo,
        DmCases: items
      };

      axios
        .post(`/DmCase/${this.fun}`, parameters)
        .then((response) => {
          if (response.status == 200) {
            this.getItemsAfterMove();
          } else this.$alertMsg(response.data.data.text, 4);
        })
        .catch((err) => {
          this.$alertMsg(err.response.data, 4);
        });
    },
    restNewBatchObj() {
      this.newBatch.activityStage = this.stageEnumId;
      this.newBatch.description = '';
      this.newBatch.assginedDate = new Date();
      this.newBatch.assignedEmployeeId = 0;
      this.newBatch.assignedDetails = '';
    },
    getItemsAfterMove() {
      axios
        .post(
          `/DmCase/GetItems?billingGroupId=${this.billingGroup == null ? '' : this.billingGroup}&projectId=${this.project}
            &activityStage=${this.stageEnumId}&status=${
            this.statusEnumId
          }&filter=''%+&includeLastPayments=true&includeBalance=true&pageIndex=0&pageSize=1000`
        )
        .then((response) => {
          if (response.status == 200) {
            this.loadProject();
            this.currentItem.data = response.data.items;

            this.$alertMsg(this.$t('deptManagement.itemsHaveBeenMovedSuccessfully'), 2);
          }
        })
        .catch((err) => {
          this.$alertMsg(err.response.data, 4);
        });
    },
    createBatch() {
      const assignedDate = moment(this.newBatch.assginedDate, 'DD/MM/YYYY').add(1, 'days');

      const parameters = {
        ActivityStage: this.newBatch.activityStage,
        Description: this.newBatch.description,
        AssignedDate: assignedDate,
        AssignedEmployeeId: this.newBatch.assignedEmployeeId,
        AssignedDetails: this.newBatch.assignedDetails
      };

      axios
        .post(`/DmCase/CreateBatch`, parameters)
        .then((response) => {
          if (response.status == 200) {
            this.showCreateNewBatchDialog = false;
            this.selectedBatchNo = response.data.batchNo;
            this.processItems();
          } else {
            this.$alertMsg(response, 4);
          }
        })
        .catch((err) => {
          this.$alertMsg(err.response.data, 4);
        });
    },
    getBatches() {
      axios
        .post(`/DmCase/GetAssignmentBatches?activityStage=${this.stageEnumId}`)
        .then((response) => {
          if (response.status == 200) {
            for (var i = 0; i < response.data.length; i++) {
              response.data[i].displayName = `[${response.data[i].batchNo}] ${response.data[i].name}`;
            }
            this.batches = response.data;
            this.showBatchesDialog = true;
          }
        })
        .catch((err) => {
          this.$alertMsg(err.response.data, 4);
        });
    },
    selectBatch() {
      if (this.selectedBatchNo == 0) {
        this.$alertMsg(this.$t('deptManagement.thereIsNoBatchSelected'), 4);
        return;
      }
      this.showBatchesDialog = false;
      this.processItems();
    },
    clearProcessData() {
      this.showProcessingData = false;
      this.showLoadingData = false;
      this.selectedBatchNo = 0;
      this.selectedItems = [];
    }
  }
};
